import React, { useEffect, useState } from "react";

import { Overview } from '../../components/SoilHealthDashboard/Overview';
import { SoilHealthExplorer } from '../../components/SoilHealthDashboard/SoilHealthExplorer';
import { AdvisoryPriority } from '../../components/SoilHealthDashboard/AdvisoryPriority';
import { FarmerProfile } from '../../components/SoilHealthDashboard/FarmerProfile';
import { FilterProvider } from '../../components/SoilHealthDashboard/components/FilterContext';
import { Navigation } from '../../components/SoilHealthDashboard/components/Navigation';
import Wrapper from '../../components/Wrapper';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";
import axiosInstance from "../../utils/axios.js";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement
);

function PartnerDashboard() {
  const [currentPage, setCurrentPage] = useState('overview');
  const [dashboardData, setDashboardData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    axiosInstance.get("/admin/dashboard-data")
      .then((res) => {
        setDashboardData(res.data.dashboardData);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Dashboard API error", err);
        setLoading(false);
      });
  }, []);

  const renderPage = () => {
    if (loading) return <p className="p-6">Loading soil health dashboard…</p>;
    switch (currentPage) {
      case 'overview':
        return <Overview />;
      case 'explorer':
        return <SoilHealthExplorer />;
      case 'advisory':
        return <AdvisoryPriority />;
      case 'profile':
        return <FarmerProfile />;
      default:
        return <Overview />;
    }
  };

  return (
    <Wrapper>
      <div className="h-full overflow-y-auto bg-[#F5F5F5] -mt-2">
        <FilterProvider>
          <Navigation
            currentPage={currentPage}
            onPageChange={setCurrentPage}
          />
          {renderPage()}
        </FilterProvider>
      </div>
    </Wrapper>
  );
}

export default PartnerDashboard;
